module.exports = __webpack_public_path__ + "static/media/bg-image-11.0a8f0dff.jpg";